import React from "react";
import { Segment } from "semantic-ui-react";
import CampaniaCard from "./CampaniaCard";
import CampaniaGenericoCard from "./CampaniaGenericoCard";
import PropTypes from "prop-types";
import {
  CODIGO_ORIGEN_CAMPANIA_MICRO,
  CODIGO_ORIGEN_CAMPANIA_MICASH,
} from "../../../app/infrastructure/appConstants";

const CampaniaList = ({ campanias }) => {
  return (
    <Segment.Group raised>
      {campanias &&
        campanias.map((campania, index) => {
          if (
            CODIGO_ORIGEN_CAMPANIA_MICRO === campania.indicadorOrigen ||
            CODIGO_ORIGEN_CAMPANIA_MICASH === campania.indicadorOrigen
          ) {
            return <CampaniaCard key={index} campania={campania} />;
          } else {
            return <CampaniaGenericoCard key={index} campania={campania} />;
          }
        })}
    </Segment.Group>
  );
};

CampaniaList.propTypes = {
  campanias: PropTypes.array.isRequired,
};

export default CampaniaList;
